/*
	To prevent raising UI issues in other places,
	this component has been created independenttly from both
	DateTimeOrNoData and DateTime components.
	---
	This version:
	(1) if the whole element overlaps the parent width, the DATE content moves into a new line
	(2) also the DATE content is wrapped if needed
	---
	Technical debt:
	(1) review the different places where both components are being used
	then (2) replace by this new version, if possible,
	(3) moving this new version into /components.
*/

import classnames from 'classnames';
import NoData from 'components/content/NoData';
import { formatDate, formatTime } from 'helper/time';
import { isDate } from 'remeda';

import './_styles.scss';

export interface ValueOrNoDataProps {
    value?: string | null;
}

interface DateTimeProps {
    date: Date;
    className?: string;
    separator?: boolean;
}

const DateTime = ({ date, className, separator }: DateTimeProps) => (
    <span data-testid='datetime-component' className={`DateTime ${className}`}>
        <span
            data-testid='datetime-component-time'
            className={classnames('DateTime__time', {
                'DateTime__time--withSeparator': !separator,
            })}
        >
            {formatTime(date)}
        </span>
        {separator && <span data-testid='datetime-component-separator'>-</span>}
        <span
            data-testid='datetime-component-date'
            className={classnames('DateTime__date', {
                'DateTime__date--withSeparator': !separator,
            })}
        >
            {formatDate(date)}
        </span>
    </span>
);

const DateOrNoData = ({ value }: ValueOrNoDataProps) =>
    value && isDate(new Date(value)) ? (
        <p>
            <DateTime date={new Date(value)} />
        </p>
    ) : (
        <NoData text='No data' className='DateOrNoData__nodata' />
    );

export default DateOrNoData;
